import SvgMarketIcon from "@/components/svg/MarketIcon";
import SvgPipelineIcon from "@/components/svg/PipelineIcon";
import SvgStrategyIcon from "@/components/svg/StrategyIcon";
import { KeyPointsType } from "@/types/consts";
import {
  Box,
  chakra,
  Heading,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";

export interface KeyPointsProps {
  icon: (typeof KeyPointsType)[keyof typeof KeyPointsType];
  title?: string;
  items: string[];
}

export default chakra(KeyPoints);
function KeyPoints({ icon, title, items }: KeyPointsProps) {
  const t = useTranslations();
  
  const defaultTitles = {
    [KeyPointsType.Strategy]: t("strategy Label"),
    [KeyPointsType.Market]: t("market Label"),
    [KeyPointsType.Pipeline]: t("pipeline Label"),
  };

  const renderIcon = () => {
    switch (icon) {
      case KeyPointsType.Strategy:
        return <SvgStrategyIcon />;

      case KeyPointsType.Market:
        return <SvgMarketIcon />;

      case KeyPointsType.Pipeline:
        return <SvgPipelineIcon />;

      default:
        return null;
    }
  };

  return (
    <Box
      minW={{ base: "100%", md: "20rem" }}
      maxW="33rem"
      flex="1 1 27rem"
      p={10}
      pr={14}
      rounded="1rem"
      color="brand.white"
      bgColor="brand.aubergine"
    >
      <Box display="flex" alignItems="center" gap={4} mb={12}>
        {renderIcon()}
        <Heading size="unset" textStyle="display.sm" fontWeight={400}>
          {title ?? defaultTitles[icon]}
        </Heading>
      </Box>
      <UnorderedList spacing={5} pl={3}>
        {items.map((item, index) => (
          //--index as key is accepted, list is static--//
          <ListItem
            key={index}
            pl={6}
            textStyle="paragraph.lg"
            sx={{ "&::marker": { color: "aubergine.300" } }}
          >
            {item}
          </ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
}
